// extracted by mini-css-extract-plugin
export default {"badge":"PlatformLabels_badge__JsLb4","icon":"PlatformLabels_icon__qFz3L","label":"PlatformLabels_label__BJDEo"};